module.exports = __webpack_public_path__ + "static/media/snowy-3.573db2ef.svg";